import {Component} from '@angular/core';
import {categoryToIcon, MilestoneCategory} from '../../../model/milestones/MilestoneCategory';

@Component({
  selector: 'digires-milestone-legend',
  templateUrl: './milestone-legend.component.html',
  styleUrls: ['./milestone-legend.component.scss']
})
export class MilestoneLegendComponent {

  public readonly category: typeof MilestoneCategory = MilestoneCategory;
  public readonly categoryToIcon = categoryToIcon;

}
